<template>
  <div class="disclaimer-logos flex justify-center items-center">
    <a
      v-for="(icon, key) in icons"
      :key="key"
      :href="icon.url"
      target="_blank"
      class="gap-2 w-32 pb-1"
    >
      <img
        :src="icon.svg"
        :alt="icon.alt"
      >
    </a>
  </div>
</template>

<script lang="ts">

import { TRUSTPILOT } from '~~/constants/trustUrls';
import type { Logo } from '~~/types/components/DisclaimerLogos/Logo';

export default defineComponent({
  name: 'DisclaimerLogos',
  setup() {

    const i18n = useI18n();

    const icons: Logo[] = [
      {
        svg: '/logos/trustpilot-logo-black.svg',
        url: TRUSTPILOT,
        alt: i18n.t('logo-trustpilot').toString(),
      },
    ];

    return {
      icons,
    };
  
  },
});

</script>
